(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultra-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ultra-banner-countdown')) {
    customElements.define('ultra-banner-countdown', class extends HTMLElement {
      connectedCallback() {
        const end = Date.parse(this.dataset.end);
        if (!Number.isFinite(end)) return;
        const values = this.querySelectorAll('[data-countdown-value]');
        const update = () => {
          const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
          const parts = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
          parts.forEach((value, index) => { values[index].textContent = String(value).padStart(2, '0'); });
          if (remaining === 0) clearInterval(this.timer);
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
